import { Component, Input } from '@angular/core';
import { Definition, DefinitionCategory } from '@emi/shared/models';

@Component({
    selector: 'via-definitions-content',
    templateUrl: './definitions-content.component.html',
    styleUrls: ['./definitions-content.component.scss']
})
export class DefinitionsContentComponent {
    @Input() public categoryDefinitions: DefinitionCategory;

    public trackDefinitions(_: number, definition: Definition): number {
        return definition.id;
    }
}
